export const ClientType = Object.freeze({
  CLIENT: "client",
  CONFERENCE: "conference",
  ORGANIZATION: "organization"
});

export const ON_DEMAND = "on-demand";
export const LIVE = "live";
export const SCHEDULED = "scheduled";
export const PLANNED = "planned";
export const NETWORK = "network";
export const USER = "user";
export const HELP = "help";
export const ACCOUNT = "account";
export const ACCOUNT_INFORMATION = "view";
export const EDIT_PERSONAL_INFO = "edit";
export const FORGOT_PASSWORD = "forgot-password";
export const PRODUCT_SUMMARY = "summary";
export const CREATE_ACCOUNT = "signup";
export const LOGIN = "signin";
export const EVENTS = "events";
export const EVENT = "event";
export const PLAYER = "player";
export const PRODUCTS = "products";
export const PURCHASE = "purchase";
export const ORDER_HISTORY = "order-history";
export const ORDER_DETAILS = "order-details";
export const VIDEO = "video";
export const AUDIO = "audio";
export const INFO = "info";

export const MOBILE_BREAKPOINT = 568;
export const TABLET_BREAKPOINT = 768;
export const L_BREAKPOINT = 991;
export const XL_BREAKPOINT = 1200;

export const GPT_LIST_DIMENSIONS = [
  [320, 50],
  [728, 90],
  [970, 90]
];

export const TOS = "https://www.prestosports.com/terms-of-service/";
export const PRIVACY_POLICY = "https://www.prestosports.com/privacy-policy";
export const FAQ =
  "https://help.prestosports.com/PrestoStream/v1/viewer-help-faq-contact-stream-support";

export const GOOGLE_AD_URL = process.env.REACT_APP_GOOGLE_AD_PLAYER_SOURCE_URL;
export const THEOPLAYER_LICENSE = process.env.REACT_APP_THEOPLAYER_LICENSE;

export const EVENT_TYPES = [
  {
    value: 0,
    text: "All Events"
  },
  {
    value: 1,
    text: "Free"
  },
  {
    value: 2,
    text: "Pay-per-view"
  }
];

export const CHILDREN_ASSOCIATION = {
  [ClientType.CLIENT]: "siblings",
  [ClientType.ORGANIZATION]: "grandchildren",
  [ClientType.CONFERENCE]: "children"
};

export const orderHistoryDropdown = [
  {
    text: "This Week",
    value: 0,
    noOrdersMsg: "You have not placed any orders for this week"
  },
  {
    text: "This Month",
    value: 1,
    noOrdersMsg: "You have not placed any orders for this month"
  },
  {
    text: "Past Year",
    value: 2,
    noOrdersMsg: "You have not placed any orders for the past year"
  }
];

export const ACCOUNT_CREATED_MESSAGE = "Success! Your account has been created";
export const ACCOUNT_CREATE_ERROR_MESSAGE =
  "There was an error while creating the account";
export const PERSONAL_INFO_UPDATED_MESSAGE =
  "Success! Your personal info has been updated";
export const SOMETHING_WENT_WRONG_MESSAGE = "Something went wrong";
export const CREDENTIALS_ERROR_MESSAGE =
  "There was something wrong with the credentials";
export const ACCOUNT_NOT_FOUND_MESSAGE =
  "We couldn't find an account with those details.";
export const ACCOUNT_FOUND_WITH_THAT_EMAIL =
  "An account with this email already exists. Please sign in or use another email address.";
export const NO_BUYER_IDENTITY_MESSAGE =
  "No identity or buyerId found for user";
export const PROVIDE_SHORTNAME_MESSAGE = "Please provide a client short name";
export const GEO_LOCATION_ERROR_MESSAGE =
  "You may need to Allow Location services in your browser settings to view certain events";

export const EVENT_STATUS = [
  { type: "live", alt: "LIVE" },
  { type: "on-demand", alt: "ONDEMAND" }
];
